<script setup>
//region Imports
import { ref, watch, onMounted, reactive } from 'vue'
//endregion
//region Methods
const readData = () => JSON.parse(localStorage.getItem('tc-claim-data'))
const readSelectedItems = () => JSON.parse(localStorage.getItem('tc-claim-selected-items'))

const toggleSelection = item => {
  item.selected = !item.selected
}

const selectEntireOrder = () => {
  if (selectedCount.value === items.length) {
    items.map(item => {
      item.selected = false
      return item
    })
    localStorage.removeItem('tc-claim-selected-items')
    return
  }

  items = items?.map(item => {
    item.selected = true
    return item
  })
}

const clickToContinue = () => {
  if (selectedCount.value === 0) {
    alert('Please select at least 1 item')
    return
  }

  localStorage.setItem('tc-claim-selected-items', JSON.stringify(selectedItems.value))
  location.replace('#/order/track')
}

const copyToClipboard = () => {
  const elem = document.querySelector('#copy-order-number .order-number')
  const label = document.querySelector('#copy-label')
  if (elem === null || label === null) return
  navigator.clipboard.writeText(elem.textContent)
  label.classList.remove('hidden')

  setTimeout(() => {
    label.classList.add('hidden')
  }, 1500)
}
//endregion
//region Variables
const selectedCount = ref(0)
const data = reactive(readData() ?? {})
const orderNumber = ref(data?.orderNumber)
const selectedEntireOrder = ref(false)
// const selectEntireOrderIcon = ref('+')
let items = reactive(data?.items?.map(item => {
  item.selected = false
  return item
}))
const selectEntireOrderLabel = ref('Select Entire Order')
const selectedItems = reactive(readSelectedItems() ?? items?.filter(item => item.selected))
//endregion
//region Lifecycle
onMounted(() => {
  if (!orderNumber.value) {
    location.replace('/')
    return
  }

  items = items?.map(item => {
    item.selected = selectedItems.some(selectedItem => selectedItem.poNumber === item.poNumber)
    return item
  })
})

watch(items, () => {
  selectedItems.value = items.filter(item => item.selected)
  selectedCount.value = selectedItems?.value?.length ?? 0
  selectedEntireOrder.value = selectedCount.value === items.length
  selectEntireOrderLabel.value = selectedCount.value === items.length ? 'Deselect All' : 'Select Entire Order'
  localStorage.setItem('tc-claim-selected-items', JSON.stringify(selectedItems.value))
}, { deep: true })
//endregion
</script>

<template>

  <figure class="w-full h-[180px] lg:h-[340px] overflow-hidden bg-no-repeat bg-right bg-cover"
          style="background-image: url(https://cdn.shopify.com/s/files/1/0067/9532/9609/files/DSC01071.png?v=1713213218);">&nbsp;</figure>

  <div class="px-[20px] mt-[30px] lg:px-[40px] lg:mt-[37px]">

    <header>

      <h1 class="font-bold text-tc-title font-minionpro text-tc-black tracking-wider"
          v-text="'Resolve Center'"
      ></h1>


      <div class="relative flex items-end gap-[7px]">
        <button v-if="orderNumber != null"
                id="copy-order-number"
                @click="copyToClipboard()"
                class="cursor-pointer flex gap-3 items-center mt-[10px]">

          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
            <g id="order-icon">
              <path id="Vector" d="M4.61364 5.21591V4.09827C4.61364 3.18684 5.29219 2.41346 6.20049 2.33807C6.50025 2.31319 6.80098 2.29174 7.10265 2.27376M10.6364 13.6477H12.4432C13.4411 13.6477 14.25 12.8388 14.25 11.8409V4.09827C14.25 3.18684 13.5714 2.41346 12.6631 2.33807C12.3634 2.31319 12.0627 2.29174 11.761 2.27376M10.6364 14.25V12.7443C10.6364 11.2475 9.42295 10.0341 7.92614 10.0341H6.72159C6.22265 10.0341 5.81818 9.62962 5.81818 9.13068V7.92614C5.81818 6.42932 4.60477 5.21591 3.10795 5.21591H2.20455M11.761 2.27376C11.5335 1.53608 10.8464 1 10.0341 1H8.82955C8.01721 1 7.33009 1.53608 7.10265 2.27376M11.761 2.27376C11.8129 2.44226 11.8409 2.62127 11.8409 2.80682V3.40909H7.02273V2.80682C7.02273 2.62127 7.0507 2.44226 7.10265 2.27376M3.40909 5.21591H1.90341C1.40447 5.21591 1 5.62038 1 6.11932V15.7557C1 16.2546 1.40447 16.6591 1.90341 16.6591H9.73295C10.2319 16.6591 10.6364 16.2546 10.6364 15.7557V12.4432C10.6364 8.45167 7.4006 5.21591 3.40909 5.21591Z" stroke="#0F172A" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
          </svg>

          <span class="text-tc-xl font-avenir tracking-wider text-black order-number" v-text="'#'+orderNumber"></span>

        </button>

        <span class="text-tc-lg text-tc-gray font-normal font-avenir tracking-wide hidden" id="copy-label">copied</span>
      </div>

      <div class="flex flex-row items-center my-[22px] justify-between">

      <span class="text-tc-2xl font-avenir"
          v-text="selectedCount < 1 ? 'Select Items' : (selectedCount === 1 ? '1 Item Selected' : `${selectedCount} Items Selected`)"
      ></span>

        <div @click="selectEntireOrder"
             :class="{ 'border-black text-red': selectedEntireOrder }"
             class="flex flex-row gap-3 items-center border border-tc-off-white-2 p-2 cursor-pointer font-avenir">
          <figure class="w-[20px] h-[20px] flex justify-center items-center bg-black">
          <span
              class="block transform text-2xl font-bold text-white animate transition-transform duration-200 ease-in-out"
              :class="{ 'transform rotate-45': selectedEntireOrder }"
          >+</span>
          </figure>
          <span class="text-tc-xl" v-text="selectEntireOrderLabel"
              :class="{ 'text-red': selectedEntireOrder }"
          ></span>
        </div>

      </div>

    </header>

    <main>
      <ul class="grid grid-cols-1 lg:grid-cols-3 gap-[20px] font-avenir">
        <li class="border p-2 bg-tc-off-white cursor-pointer relative flex"
            v-for="item in items" :key="item.poNumber"
            :class="{ 'border-black': item.selected, 'border-tc-off-white': !item.selected }"
            @click="toggleSelection(item)"
        >
          <img :src="item.image" alt="Image" class="w-[62px] float-left mr-2">
          <div class="flex flex-col justify-center gap-[7px]">
            <span class="text-tc-2xl font-normal text-black tracking-wider leading-tight">{{ item.name.split('/')[0] }}</span>
            <span class="text-tc-xl font-normal tracking-wider text-tc-gray">{{ item.poNumber }}</span>
          </div>
          <div v-if="item.selected" class="absolute top-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
              <rect width="17" height="17" fill="#2E1319"/>
              <path d="M4.5 8L7 10.5L12 5.5" stroke="#F9F9F0" stroke-width="2"/>
            </svg>
          </div>
        </li>
      </ul>

      <button type="submit"
          @click="clickToContinue"
          class="text-tc-2xl text-white font-medium bg-tc-maroon h-[65px] w-full lg:max-w-[210px] mt-[30px] font-avenir"
      >Next
      </button>

      <hr class="w-full h-0.5 bg-tc-off-white-two my-[20px] lg:my-[30px]">

      <ul class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-10 font-avenir" v-if="data != null">
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Order Number</span>
          <span class="text-tc-lg" v-text="orderNumber ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Store Order ID</span>
          <span class="text-tc-lg" v-text="data?.shopifyOrderId ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Order Date</span>
          <span class="text-tc-lg" v-text="data?.orderDate ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Estimated Delivery Date</span>
          <span class="text-tc-lg" v-text="data?.estimatedDeliveryDate ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Email</span>
          <span class="text-tc-lg" v-text="data?.customerEmail ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Shipped To</span>
          <span class="text-tc-lg" v-text="data?.shippingAddress ?? 'N/A'"></span>
        </li>
      </ul>

      <hr class="w-full h-0.5 bg-tc-off-white-two my-[20px] lg:my-[30px]">

      <h3 class="mb-[12px] flex items-center gap-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
          <path d="M8.053 6.916H9.067V13H8.053V6.916ZM7.819 4.537C7.819 4.33767 7.88833 4.16433 8.027 4.017C8.17433 3.86967 8.352 3.796 8.56 3.796C8.768 3.796 8.94133 3.86967 9.08 4.017C9.22733 4.16433 9.301 4.33767 9.301 4.537C9.301 4.75367 9.23167 4.93133 9.093 5.07C8.95433 5.20867 8.77667 5.278 8.56 5.278C8.34333 5.278 8.16567 5.20867 8.027 5.07C7.88833 4.93133 7.819 4.75367 7.819 4.537Z" fill="#2E1319"/>
          <rect x="0.5" y="0.5" width="16" height="16" rx="8" stroke="#2E1319"/>
        </svg>
        <span class="text-tc-lg text-tc-muted-brown font-medium">Support</span>
      </h3>

      <ul class="grid grid-cols-1 gap-[12px] lg:mb-[30px]">
        <li><a href="https://help.trescolori.com" class="text-tc-lg underline" target="_blank">View Help Center</a></li>
        <li><a href="mailto:info@trescolori.com" class="text-tc-lg underline" target="_blank">info@trescolori.com</a></li>
      </ul>

    </main>

  </div>

</template>

<style scoped>
.modal {
  width: 300px;
  padding: 30px;
  box-sizing: border-box;
  background-color: #fff;
  font-size: 20px;
  text-align: center;
}
</style>